import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useTheme } from "@/providers/theme-provider";
import { Info, Moon, Sun } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "@/components/ui/dialog";
import { Button } from "../ui/button";
import { DialogHeader } from "../ui/dialog";
import { Link } from "../links";

const themes: [string, JSX.Element][] = [
  [
    "Dark",
    <Moon fontSize="48px" size={48} className="rotate-90 transition-all dark:rotate-0 " />,
  ],
  [
    "Light",
    <Sun className="h-[1.2rem] w-[1.2rem] rotate-0 transition-all dark:-rotate-90" />,
  ],
];

export function AppearanceSettings() {
  const { theme, setTheme } = useTheme();
  const [showRoadmapAlert, setShowRoadmapAlert] = useState(false);
  const onValueChange = (value: string) => {
    setTheme(value as any);
  };
  return (
    <>
      <h4>
        Theme: <span className="dark:inline hidden">Dark</span>
        <span className="inline dark:hidden">Light</span>
      </h4>

      <ToggleGroup
        type="single"
        variant="outline"
        onValueChange={onValueChange}
        value={theme}
        className="gap-3 mb-5"
      >
        {themes.map(([theme, icon]) => (
          <ToggleGroupItem
            key={`t${theme}`}
            className="border rounded-md flex flex-col w-24 h-24 [&_svg]:size-6"
            value={theme.toLowerCase()}
          >
            <span></span>
            <div className="text-3xl">{icon}</div>
            <span className="mt-1">{theme}</span>
          </ToggleGroupItem>
        ))}
      </ToggleGroup>
      <div className="flex items-center justify-between">
        <h4 className="inline">Reduced motion: Off</h4>
        <Switch
          checked={false}
          onCheckedChange={() => {
            setShowRoadmapAlert(true);
          }}
        />
        <MyAlert
          show={showRoadmapAlert}
          setShow={setShowRoadmapAlert}
          title="Roadmap item"
          description={
            <>
              <p>This feature has not been implemented.</p>
              <p>
                If it is important to you, <Link to="https://docs.myth.finance/dualSTAKE/contact">get in touch</Link> and help us prioritize it!
              </p>
            </>
          }
        />
      </div>
    </>
  );
}

export default function MyAlert({
  show,
  setShow,
  title,
  description,
}: {
  show: boolean;
  setShow: (b: boolean) => void;
  title: string;
  description: JSX.Element;
}) {
  return (
    <Dialog open={show} onOpenChange={setShow}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 mb-2">
            <Info className="w-5 h-5" />
            {title}
          </DialogTitle>
          <DialogDescription className="flex flex-col gap-1 items-start text-left">
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2">
          <DialogClose asChild>
            <Button variant="outline">Dismiss</Button>
          </DialogClose>
        </div>
      </DialogContent>
    </Dialog>
  );
}
